import AsyncStorage from '@react-native-async-storage/async-storage';
import { type Href, router } from 'expo-router';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

type ActiveContextPathname = '/organization' | '/team';

interface RootStoreState {
  activeTab: string;
  activeContextPathname: ActiveContextPathname | null;
  organizationId: string | null;
  teamId: string | null;
  dismissedUpdateId: string | null;
  pendingEmailLink: string | null;
  magicLinkEmail: string | null;
  isDrawerOpen: boolean;
}

const initialState: RootStoreState = {
  activeTab: 'event',
  activeContextPathname: null,
  organizationId: null,
  teamId: null,
  dismissedUpdateId: null,
  pendingEmailLink: null,
  magicLinkEmail: null,
  isDrawerOpen: false,
};

const useRootStore = createWithEqualityFn<RootStoreState>()(
  persist(() => initialState, {
    name: 'useRootStore',
    storage: createJSONStorage(() => AsyncStorage),
    partialize: (state) => ({
      activeTab: state.activeTab,
      activeContextPathname: state.activeContextPathname,
      organizationId: state.organizationId,
      teamId: state.teamId,
      dismissedUpdateId: state.dismissedUpdateId,
      magicLinkEmail: state.magicLinkEmail,
    }),
  }),
);

export const openDrawer = () => {
  useRootStore.setState({ isDrawerOpen: true });
};

export const closeDrawer = () => {
  useRootStore.setState({ isDrawerOpen: false });
};

export const navigateFromDrawer = (href: Href) => {
  closeDrawer();
  router.navigate(href);
};

export const gotoOrganizationDetail = (organizationId: string) => {
  router.replace({
    pathname: '/organization',
    params: { organizationId },
  });
};

export const gotoTeamDetail = (teamId: string) => {
  router.replace({
    pathname: '/team',
    params: { teamId },
  });
};

export default useRootStore;
